import { Header } from '@/components/header'
import { Footer } from '@/components/footer'
import { AssociationsAndSuppliers } from '@/components/AssociationsAndSuppliers'
import { Helmet } from 'react-helmet-async'

export default function About() {
  return (
    <main>
      <Helmet>
        <title>About Busy Beaver Construction | Calgary's Premier Deck & Fence Builder</title>
        <meta name="description" content="Busy Beaver Construction is Calgary's longest operating deck and fence builder since 1999. Family-owned, specializing in custom decks, fences and outdoor living spaces." />
        <meta name="keywords" content="Busy Beaver Construction, Calgary deck builder, deck company Calgary, fence contractor Calgary, custom outdoor living spaces, BBB A+ rated deck builder" />
        <link rel="canonical" href="https://busybeaverconstruction.com/about" />
        <meta property="og:title" content="About Busy Beaver Construction | Calgary's Premier Deck Builder" />
        <meta property="og:description" content="Serving Calgary since 1999, Busy Beaver Construction is the leader in custom decks, fences, and outdoor living spaces for residential and commercial properties." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://busybeaverconstruction.com/about" />
        <meta property="og:image" content="https://busybeaverconstruction.com/assets/images/Decks/Composite Decks/timbertech-composite-stock.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="preload" href="/assets/images/Decks/Composite Decks/timbertech-composite-stock.jpg" as="image" />
      </Helmet>
      <Header />

      {/* Hero Banner */}
      <section className="relative h-[400px] flex items-center justify-center">
        <img 
          src="/assets/images/Decks/Composite Decks/timbertech-composite-stock.jpg"
          alt="Busy Beaver Construction TimberTech composite deck installation in Calgary"
          className="absolute inset-0 w-full h-full object-cover loading-eager"
          fetchPriority="high"
        />        
        <div className="relative z-10 mt-64 text-center">
          <div className="inline-block bg-busy-green rounded py-3 mx-4 px-4 lg:px-8">
            <p className="text-white text-base font-medium rounded">The Longest Operating Deck Builder in Calgary</p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container">
          <h1 className="text-center text-5xl lg:text-6xl font-primary ">About Busy Beaver Construction</h1>
          <p className="text-center text-xl text-gray-500 mb-8 md:mb-14">It's all in the name.</p>
          
          <div className=" mx-auto space-y-6 text-gray-500 text-base leading-relaxed">
            <p>
              <strong className="font-semibold">Busy Beaver Construction</strong> is a full-service, outdoor construction company that specializes in Custom Decks, Fences, and outdoor Living Spaces. Since 1999, Busy Beaver has been serving the Calgary area delivering beautiful, customized decks and fences. Whether you are looking for a simple deck, or a complete backyard makeover, we offer customized solutions that address each client's budget, taste, and preferences.
            </p>
            
            <p>
              What started as a small, one crew operation, has now grown to be Calgary's leading and longest running deck and fence builder for residential and commercial properties. With more than 25 years of experience, this family-owned operation continuously strives to build a name and reputation as the leader in quality custom decks and fences.
            </p>
            
            <p>
              Our team is selected carefully to ensure the highest of standards, professionalism and comprehensive knowledge in the outdoor construction industry. We ensure our team is receiving frequent training and certification to keep up with industry advancements. Our installation crews approach each project with a foundation of strong design aesthetics, and commitment to quality craftsmanship.
            </p>
            
            <p>
              Busy Beaver is a proud A+ member of the Better Business Bureau. We take pride in building beautiful outdoor spaces that exceed our client's expectations. We love what we do and are confident you will enjoy working with us from the design process till the project is complete.
            </p>
            
            <p>
              Please check out our <a href="/services" className="text-beaver-red hover:underline">project gallery</a>, read through our <a href="/testimonials" className="text-beaver-red hover:underline">spectacular reviews</a>, and when you are ready to start your project <a href="/appointment" className="text-beaver-red hover:underline">we are here to help</a>.
            </p>
          </div>
        </div>
      </section>

      {/* Client Testimonials */}
      <section className="py-24 relative lg:mb-10">
        <div className="absolute inset-0">
          <img 
            src="/assets/images/Other/Living Spaces/Outdoor-covered-Living-Space-on-Mahogany-lake.jpeg"
            alt="Custom outdoor covered living space by Busy Beaver Construction on Mahogany lake in Calgary"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-black/70"></div>
        
        <div className="container relative z-10">
          <h2 className="text-center text-5xl lg:text-6xl font-script text-white mb-12">Clients on Busy Beaver Construction</h2>
          
          <div className="max-w-3xl mx-auto">
            <blockquote className="text-white text-lg italic leading-relaxed mb-6">
              "Francois and Christine were both a real pleasure to work with from quote to completing the project. We absolutely love our deck. Each phase of the project was executed with professionalism and everyone was super friendly. They used quality materials and our deck is a solid structure. It looks modern and we are proud to show it off. Busy Beaver is the best."
            </blockquote>
            <div className="text-right text-white">
              <p className="font-bold">- Joe Shenfield</p>
            </div>
          </div>
        </div>
      </section>

            {/* Associations and Suppliers Section - now using the component */}
            <AssociationsAndSuppliers />

      <Footer />
    </main>
  )
} 